import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.css';

class InputUnit extends Component {
	render() {
		const { unit } = this.props;
		return <span className="input-unit">{unit}</span>;
	}
}
InputUnit.propTypes = {
	unit: PropTypes.string
};
export default InputUnit;
